import { Button } from 'antd'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import DateCell from '../../../elements/Table/Cells/DateCell'
import CustomTable from '../../../elements/Table/CustomTable'

function List(props) {
  const { list, fetch, fetching } = props
  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      width: 100,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/warranty/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'S/N',
      accessor: '_key',
      width: 120,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/warranty/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Identifier',
      accessor: 'oemSerial',
      width: 120,
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'name',
      accessor: 'name',
      style: { paddingLeft: 20, alignment: 'left' },
      //width: 150
    },
    /*{
      Header: 'model',
      accessor: 'model',
    },*/
    {
      Header: 'company',
      accessor: 'company.fn',
      width: 300
    },
    {
      Header: 'Customer',
      accessor: 'sale.customer.fn',
      width: 300
    },
    {
      Header: 'Sales Order',
      accessor: 'sale.salesOrder.code',
      width: 100
    },
    {
      Header: 'Issue Date',
      accessor: 'sale.warranty.startDate',
      Cell: DateCell,
      width: 100
    },
    {
      Header: 'End Date',
      accessor: 'sale.warranty.endDate',
      Cell: DateCell,
      width: 100
    },
    {
      Header: 'Vendor',
      accessor: 'purchase.vendor.fn',
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'Purchase Order',
      accessor: 'purchase.order.code',
      width: 100,
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'allocation',
      accessor: 'allocation',
      width: 100,
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'allocationType',
      accessor: 'allocationType',
      width: 100,
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
    },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
      CreateButton={() => (
        <Link className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" to={`/warranty/new/`}>
          New
        </Link>
      )}
      defaultSorted={[
        {
          id: 'code',
          desc: true,
        },
      ]}
    />
  )
}

export default List
